import React, { FC } from 'react';
import { Connect } from './NotificationReadStatusContainer';
import styles from './notification_read_status.module.scss';

type Props = {
  isAlreadyRead: boolean;
};

export const RawNotificationReadStatus: FC<Props> = ({ isAlreadyRead }) => {
  if (isAlreadyRead) return null;

  return (
    <span
      className={styles.container}
      data-test-id="notification-unread-status"
    />
  );
};

export const NotificationReadStatus = Connect(RawNotificationReadStatus);
